import { connect } from 'react-redux';
import React, { useLayoutEffect, useState } from 'react';
import { getComments, postComment } from '@actions/individualPortal/ticket/ticketActionCreators';
import { configs } from '@constants/configs/configs';
import CommentList from '@components/individualPortal/ticket/CommentList';

const TicketCommentContainer = (props) => {
    const {
        getComments,
        postComment,
        encTicketId 
    } = props;
    const [commentData, setCommentData] = useState(null);

    useLayoutEffect(() => {
        getComments(configs.endpoints.COMMENTS.processReplacements({ id: encTicketId })).then(response => {
            if (response) {
                setCommentData(response);
            }
        });
    }, []);

    const postCommentHandler = (newComment, setNewComment) => {
        if(newComment.trim() !== ''){
            postComment(configs.endpoints.SAVE_COMMENT.processReplacements({ id: encTicketId  }), {
                type: 'TICKET_PUBLIC',
                targetId: encTicketId,
                commentText: newComment,
                userId: window.UID,
            }).then(response => {
                if(response){
                    setNewComment('');
                    getComments(configs.endpoints.COMMENTS.processReplacements({ id: encTicketId  })).then(response => {
                        if (response) {
                            setCommentData(response);
                        }
                    });
                }
            });
        }
    };
    props = { ...props, postCommentHandler, commentData, setCommentData };
    return ( <CommentList props={{ props }}/> );
};

export default connect(null, { getComments, postComment })(TicketCommentContainer);